// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var ArrowLeft = function ArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.54 10.682a.95.95 0 0 1-.29-.68c0-.258.105-.5.29-.68L8.413 2.76a.937.937 0 0 1 1.293 1.355l-5.18 4.95h13.286c.519 0 .937.418.937.937s-.418.938-.937.938H4.527l5.184 4.945a.938.938 0 0 1-1.293 1.356l-6.875-6.563z"
  }));
};
